const SEARCH_HISTORY_KEY = 'strangers_map_search_history_v1';
const MAX_SEARCH_HISTORY_ITEMS = 10;

const hasValidCenter = (center) => (
  Array.isArray(center) &&
  center.length >= 2 &&
  Number.isFinite(parseFloat(center[0])) &&
  Number.isFinite(parseFloat(center[1]))
);

const normalizeEntry = (entry) => {
  if (!entry || typeof entry !== 'object') {
    return null;
  }

  const placeName = (entry.place_name || '').toString().trim();
  const center = entry.center;
  if (!placeName || !hasValidCenter(center)) {
    return null;
  }

  return {
    place_name: placeName,
    center: [parseFloat(center[0]), parseFloat(center[1])],
    updated_at: Number.isFinite(entry.updated_at) ? entry.updated_at : Date.now()
  };
};

export const getSearchHistory = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(SEARCH_HISTORY_KEY);
    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map(normalizeEntry)
      .filter((entry) => entry !== null)
      .sort((a, b) => b.updated_at - a.updated_at)
      .slice(0, MAX_SEARCH_HISTORY_ITEMS);
  } catch (error) {
    return [];
  }
};

export const saveSearchHistoryEntry = (placeName, center) => {
  const normalizedName = (placeName || '').toString().trim();
  if (!normalizedName || !hasValidCenter(center)) {
    return getSearchHistory();
  }

  const nextEntry = {
    place_name: normalizedName,
    center: [parseFloat(center[0]), parseFloat(center[1])],
    updated_at: Date.now()
  };

  const history = getSearchHistory().filter(
    (entry) => entry.place_name.toLowerCase() !== normalizedName.toLowerCase()
  );

  const nextHistory = [nextEntry, ...history].slice(0, MAX_SEARCH_HISTORY_ITEMS);

  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(nextHistory));
    } catch (error) {
      return nextHistory;
    }
  }

  return nextHistory;
};

export const removeSearchHistoryEntry = (placeName) => {
  const normalizedName = (placeName || '').toString().trim().toLowerCase();
  if (!normalizedName) {
    return getSearchHistory();
  }

  const nextHistory = getSearchHistory().filter(
    (entry) => entry.place_name.toLowerCase() !== normalizedName
  );

  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(nextHistory));
    } catch (error) {
      return nextHistory;
    }
  }

  return nextHistory;
};
